// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-secondary-button-49d2004c"};